import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

import { ERROR_MESSAGES } from "constants/validation";

/**
 * Link Schema
 * Represents administrative transactions in the system
 * Base schema is loose to allow loading legacy data.
 */
export const LinkSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    tracking: Yup.string().nullable(),
    trackingCustom: Yup.string().nullable(),
    createdAt: Yup.date().nullable(),
    updatedAt: Yup.date().nullable(),
  });

/**
 * Link Validation Schema
 * Strict rules applied only during form submission.
 */
export const LinkValidationSchema = LinkSchema.clone().shape({
  tracking: Yup.string().required(ERROR_MESSAGES.TRACKING_DATA_REQUIRED),
  createdAt: Yup.date().required(ERROR_MESSAGES.REQUIRED),
  updatedAt: Yup.date().required(ERROR_MESSAGES.REQUIRED),
});
